import { FiAlertTriangle, FiAlertOctagon, FiInfo } from '@/components/react-icons/main';

const getErrorInfo = (operationLogs) => {
  const errorOperationLogs = operationLogs?.filter((n) => n?.actionStatus === 'error');
  const warningOperationLogs = operationLogs?.filter((n) => n?.actionStatus === 'warn');
  const infoOperationLogs = operationLogs?.filter((n) => n?.actionStatus === 'info');

  if (errorOperationLogs?.length === 0 && warningOperationLogs?.length === 0 && infoOperationLogs?.length === 0) {
    return { icon: null, label: null, status: null };
  }

  const status = errorOperationLogs?.length > 0 ? 'error' : warningOperationLogs?.length > 0 ? 'warn' : 'info';
  let label = '';
  const icon = status === 'error' ? FiAlertOctagon : status === 'warn' ? FiAlertTriangle : FiInfo;

  if (errorOperationLogs?.length > 0) {
    label = `${errorOperationLogs?.length} error${errorOperationLogs?.length === 1 ? '' : 's'}`;
  }

  if (warningOperationLogs?.length > 0) {
    label = label ? `${label}, ${warningOperationLogs?.length} warning${warningOperationLogs?.length === 1 ? '' : 's'}` : `${warningOperationLogs?.length} warning${warningOperationLogs?.length === 1 ? '' : 's'}`;
  }

  if (infoOperationLogs?.length > 0) {
    label = label ? `${label}, ${infoOperationLogs?.length} info` : `${infoOperationLogs?.length} info`;
  }

  return {
    icon,
    label,
    status
  };
};

export default getErrorInfo;
